import {RouterModule, Routes} from '@angular/router';
import {LoginSignupComponent} from './components/login-signup/login-signup.component';
import {HomeComponent} from './components/home/home.component';
import {ResetPasswordComponent} from './components/login-signup/reset-password/reset-password.component';
import {SavedFilesComponent} from './components/saved-files/saved-files.component';
import {ModuleWithProviders} from '@angular/core';
import {AccountActivationComponent} from './components/login-signup/account-activation/account-activation.component';
import {NoConnectionComponent} from './components/no-connection/no-connection.component';
import {AuthGuard} from './service/auth-guard.service';
import {InfoComponent} from "./components/info/info.component";
const appRoutes: Routes = [
  {
    path: 'auth',
    component: LoginSignupComponent
  },
  {
    path: '',
    component: InfoComponent
  },
  {
    path: 'error',
    component: NoConnectionComponent
  },
  {
    path: 'home',
    component: HomeComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'saved-files',
    component: SavedFilesComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'activate/:token',
    component: AccountActivationComponent
  },
  {
    path: 'reset-password/:token',
    component: ResetPasswordComponent
  }
];
export const routing: ModuleWithProviders = RouterModule.forRoot(appRoutes);



// WEBPACK FOOTER //
// /var/www/asna/front-end/public_html/src/app/app-routes.ts